import * as React from 'react';
import { ContainerEmailPreview } from '../../email-preview';
import { FieldValues, UseFormWatch } from 'react-hook-form';

interface DocumentPreviewModalProps {
	caseName: string;
	descriptionText?: string;
	watch: UseFormWatch<FieldValues>;
}

export const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
	caseName,
	descriptionText,
	watch,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	React.useEffect(() => {
		const fetchHtml = async (): Promise<void> => {
			const signByDate = watch('sign_by_date');

			const response = await fetch(
				`/email-templates/client/${
					signByDate ? 'review-document' : 'review-document-without-sign'
				}.html`
			);
			const html = await response.text();

			const documentName = watch('document_name');

			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Document Name]',
					documentName
				);

				if (descriptionText) {
					contentElement.innerHTML = contentElement.innerHTML.replace(
						/We have reviewed your case\s*\[Case Name\],\s*and require additional\s*documentation to proceed\./g,
						descriptionText.replaceAll('\n', '<br/>')
					);
				} else {
					contentElement.innerHTML = contentElement.innerHTML.replace(
						'[Case Name]',
						caseName
					);
				}

				const listItems = contentElement.querySelectorAll('li');
				listItems.forEach((item) => {
					if (item.textContent === '[Customizable]') {
						item.remove();
					}
				});

				const parentList =
					contentElement.querySelector('ul') ||
					contentElement.querySelector('ol');

				if (parentList) {
					const additionalItems = [documentName];

					additionalItems.forEach((doc) => {
						const newItem = document.createElement('li');
						newItem.textContent = doc;
						parentList.appendChild(newItem);
					});
				}

				if (signByDate) {
					contentElement.innerHTML = contentElement.innerHTML.replace(
						/\[signature\s+by\s+date\]/g,
						signByDate
					);
				}
			}
			setHtmlContent(contentElement?.outerHTML || '');

			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			<style>
				{`
                    ${stylesContent}
                    .centerAlign {
                        text-align: center;
                        margin: 0 auto 0 auto;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    @media only screen and (min-width: 1700px) {
                        .containerGlobal {
                            background-repeat: round;
                        }
                    }
                `}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
